import React from "react";

import {
  Button,
  Dialog,
  DialogContent,
  Divider,
  Grid,
  Slide,
  Typography,
  IconButton
} from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";

import { useAppDispatch, useAppSelector } from "../../hooks/reduxhook";
import {
  changeIndex,
  getshowSources,
  removeshowSources,
} from "../../redux/slices/showSourcesSlice";
import { Close } from "@mui/icons-material"; 

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ExcerptDisplay = () => {
  const data = useAppSelector(getshowSources);
  const dispatch = useAppDispatch();

  const handleClose = () => {
    dispatch(removeshowSources());
  };

  return (
    <Dialog
      open={data?.show}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
      fullWidth={true}
      maxWidth={"md"}
    >
             <IconButton
        aria-label="close"
        onClick={handleClose}
        size="small"
        sx={{
          position: 'absolute',
          right: 2,
          top: 2,
      
        }}
      >
        <Close sx={{color : "gray"}}  fontSize="small"/>
      </IconButton>
      <DialogContent sx={{ p: 4 }}>
        <Typography fontWeight="bolder">
          {data?.sourcesArray[data?.index]?.page && (
            <>{data?.sourcesArray[data?.index]?.page} of </>
          )}
          {
            data?.sourcesArray[data?.index]?.source
              .split("/")[2]
              .split("---")[0]
          }
          .{data?.sourcesArray[data?.index]?.source.split("/")[2].split(".")[1]}
          &nbsp;&nbsp;
        </Typography>
        <Divider
          sx={{
            my: 1,
          }}
        />
        <Grid
          sx={{
            mb: 4,
            maxHeight: "350px",
            overflow: "auto",
          }}
        >
          {data?.sourcesArray[data?.index]?.text.split("\n").map((t, i) => (
            <Typography key={i}>{t}</Typography>
          ))}
        </Grid>

        <Grid container justifyContent="space-between">
          <Button
            onClick={() => {
              if (data?.index > 0) dispatch(changeIndex(data?.index - 1));
            }}
            disabled={data?.index === 0}
            variant="contained"
            color="primary"
          >
            Previous
          </Button>
          <Button
            onClick={() => {
              if (data?.index < data?.sourcesArray.length - 1)
                dispatch(changeIndex(data?.index + 1));
            }}
            disabled={data?.index === data?.sourcesArray.length - 1}
            variant="contained"
            color="primary"
          >
            Next
          </Button>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default ExcerptDisplay;
